import React from 'react'

import {
  RouteProps,
  Route,
  Redirect,
  useHistory,
  useLocation
} from 'react-router-dom'

import { useStores } from 'presentation/hooks/use-stores'
import { Profile } from 'common/enum/profile'
import { useSearchParams } from 'presentation/hooks/use-search-params'
import isBase64 from 'presentation/utils/is-base-64'

type Props = {
  profile?: Profile[]
} & RouteProps

const HospitalPrivateRoute: React.FC<Props> = (props: Props) => {
  const history = useHistory()
  const searchParams = useSearchParams()
  const encodedParams = isBase64(searchParams.toString())
    ? searchParams.toString()
    : btoa(searchParams.toString())
  const location = useLocation()
  const account = useStores()?.currentAccount?.getCurrentAccount()

  if (!account?.accessToken) {
    history.push({
      pathname: '/login',
      search: encodedParams,
      state: { pathname: location.pathname }
    })
  }

  const canAccessRoute = () =>
    props.profile?.some((profile) => account?.user?.groups?.includes(profile))

  return account?.accessToken && canAccessRoute() ? (
    <Route {...props} />
  ) : (
    <Route
      {...props}
      component={() => (
        <Redirect
          to={{
            pathname: '/login',
            search: encodedParams,
            state: { pathname: location.pathname }
          }}
        />
      )}
    />
  )
}

export default HospitalPrivateRoute
